export default __webpack_public_path__ + "static/media/choujinag_1.47072f74.png";